if (!window.customElements.get("component-pair-slider")) {
  class PairSlider extends HTMLElement {
    constructor() {
      super();

      this.selectors = {
        swiper: "swiper-container",
        prevEl: ".custom-prev-button",
        nextEl: ".custom-next-button",
      }

      this.slider = this.querySelector(this.selectors.swiper);
      this.buttonPrev = this.querySelector(this.selectors.prevEl);
      this.buttonNext = this.querySelector(this.selectors.nextEl);
      this.isInitialized = false;
    }

    connectedCallback() {
      if (this.isInitialized) return;
      if (!this.slider) return;
      this.initSlider();
      this.isInitialized = true;
    }

    initSlider() {
      const swiperParams = {
        slidesPerView: "auto",
        watchOverflow: true,
        spaceBetween: 6,
        navigation: {
          nextEl: this.buttonNext,
          prevEl: this.buttonPrev,
        },
      };

      Object.assign(this.slider, swiperParams);

      this.slider.initialize();
    }
  }

  customElements.define('component-pair-slider', PairSlider);
}
